import axios from "axios";
import { BASE_API_URL } from "../constants/apiUrls";
export async function getBackgroundVideos(page:number, limit:number){
    return (await axios.get(`${BASE_API_URL}/enterprise-background?page=${page}&limit=${limit}`)).data;
}